module.exports = __webpack_public_path__ + "static/media/Eeshan_2.fea04f10.jpg";